import React from 'react';
import classNames from 'classnames';
import css from './ListingTypeChipBar.module.css';

const CHIPS = [
  { label: 'All', value: null },
  { label: 'Boats', value: 'boat-rental' },
  { label: 'Captains', value: 'captains-crew-transport' },
  { label: 'Delivery', value: 'dock-ramp-delivery' },
  { label: 'Storage', value: 'buoys-moorage-storage' },
  { label: 'Services', value: 'marine-services' },
  { label: 'Gear', value: 'accessory-rental' },
];

const CHIP_LABELS = CHIPS.reduce((acc, c) => {
  if (c.value) acc[c.value] = c.label;
  return acc;
}, {});

const parseSelected = rawValue => {
  if (!rawValue) return [];
  const s = rawValue.toString();
  return s.startsWith('has_any:')
    ? s.slice('has_any:'.length).split(',').map(v => v.trim()).filter(Boolean)
    : [s];
};

const ListingTypeChipBar = ({ validQueryParams, onSubmit, className }) => {
  const selected = parseSelected(validQueryParams?.pub_listingType);

  const handleChipClick = value => {
    if (value === null) {
      onSubmit({ pub_listingType: null });
      return;
    }
    const next = new Set(selected);
    next.has(value) ? next.delete(value) : next.add(value);
    const values = [...next];
    onSubmit({ pub_listingType: values.length > 0 ? `has_any:${values.join(',')}` : null });
  };

  const handleRemove = value => {
    const next = selected.filter(v => v !== value);
    onSubmit({ pub_listingType: next.length > 0 ? `has_any:${next.join(',')}` : null });
  };

  return (
    <div className={classNames(css.root, className)}>
      <div className={css.chipBar}>
        {CHIPS.map(chip => {
          const isAll = chip.value === null;
          const isSelected = isAll ? selected.length === 0 : selected.includes(chip.value);
          return (
            <button
              key={chip.label}
              type="button"
              className={classNames(css.chip, { [css.chipSelected]: isSelected })}
              onClick={() => handleChipClick(chip.value)}
            >
              {chip.label}
            </button>
          );
        })}
      </div>
      {selected.length > 0 && (
        <div className={css.activeFilters}>
          {selected.map(value => (
            <span key={value} className={css.tag}>
              {CHIP_LABELS[value] || value}
              <button
                type="button"
                className={css.tagRemove}
                onClick={() => handleRemove(value)}
                aria-label={`Remove ${CHIP_LABELS[value] || value} filter`}
              >
                ✕
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default ListingTypeChipBar;
